import * as React from 'react';
import {
  usePrepareContractWrite,
  useContractWrite,
  useWaitForTransaction,
} from 'wagmi';
import { multiMint } from '../multiMint.js';
export function Withdraw(props) {
  const {
    config,
    error: prepareError,
    isError: isPrepareError,
  } = usePrepareContractWrite({
    address: multiMint.addr,
    abi: multiMint.abi,
    functionName: 'withdraw',
  });
  const { data, error, isError, write } = useContractWrite(config);
  const { isLoading, isSuccess } = useWaitForTransaction({
    hash: data?.hash,
  });

  return (
    <>
      <div>
        <div>
          <br></br>
        </div>
        <div>Balance: {props.bal} ETH</div>
        <button
          className='btn btn-primary'
          disabled={!write || isLoading}
          onClick={() => write()}
        >
          {isLoading ? 'Withdrawing...' : 'Withdraw'}
        </button>
        {isSuccess && (
          <div>
            Successfully withdrew your funds!
            <div>
              <a href={`https://etherscan.io/tx/${data?.hash}`}>Etherscan</a>
            </div>
          </div>
        )}
        {(isPrepareError || isError) && (
          <div>Error: {(prepareError || error)?.message}</div>
        )}
      </div>
    </>
  );
}
